import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export class LoadingDialog {
  spinnerClassName = "";
  messageClassName = "";
  containerClassName = "";
  message = "";
  srMessage = "";
  width = "600px";
}

@Component({
    selector: 'app-dialog-loading',
    templateUrl: './dialog-loading.component.html',
    styleUrls: ['./dialog-loading.component.css'],
    standalone: false
})
export class DialogLoadingComponent {
  loadingDialog: LoadingDialog;

  constructor(@Inject(MAT_DIALOG_DATA) public data: LoadingDialog) {
    this.loadingDialog = data;
    // Set Screen reader message to normal message when nothing is passed.
    if (!this.loadingDialog.srMessage) {
      this.loadingDialog.srMessage = this.loadingDialog.message;
    }

  }
}
